// 产品页假变体
const productVariantBtns = document.querySelectorAll(".product-variant-btn");
productVariantBtns.forEach(function (productVariantBtn) {
  productVariantBtn.setAttribute("role", "tablist");
  const variantItem = productVariantBtn?.querySelectorAll(".item");
  variantItem?.forEach(function (item) {
    item.setAttribute("role", "tab");
    if (item.classList.contains("active")) {
      item.setAttribute("aria-selected", "true");
    }
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const skipLinks = document.querySelectorAll('.skip-link, .skip-to-content-link');
  skipLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(e.currentTarget.hash);
      if (!target) return;
      const hadTabindex = target.hasAttribute('tabindex');
      if (!hadTabindex) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start' });
      if (!hadTabindex) {
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
    });
  });

  document.querySelectorAll('.site-nav--has-dropdown, .site-header-top-link-item').forEach((item) => {
    const trigger = item.querySelector(':scope > [aria-expanded][aria-controls]');
    if (!trigger) return;
    const updateState = () => trigger.setAttribute('aria-expanded', String(item.matches(':hover') || item.contains(document.activeElement)));
    item.addEventListener('focusin', updateState);
    item.addEventListener('focusout', () => requestAnimationFrame(updateState));
    item.addEventListener('mouseenter', updateState);
    item.addEventListener('mouseleave', updateState);
    if (trigger.getAttribute('href') === '#') {
      trigger.addEventListener('click', (event) => event.preventDefault());
    }
  });
});


function announcementAccessFun() {
  document.addEventListener('DOMContentLoaded', function () {
    const announcement = document.getElementById('accessibility-announcement');
    // 创建一个函数来发布声明
    function announceAccessibilityStatement() {
      // 将声明的内容复制到屏幕可见区域
      const visibleAnnouncement = document.createElement('div');
      visibleAnnouncement.style.position = 'absolute';
      visibleAnnouncement.style.top = '0';
      visibleAnnouncement.style.left = '0';
      visibleAnnouncement.style.width = '1px';
      visibleAnnouncement.style.height = '1px';
      visibleAnnouncement.style.overflow = 'hidden';
      visibleAnnouncement.innerHTML = announcement.innerHTML;
      document.body.appendChild(visibleAnnouncement);
      // 移除声明内容（可选）
      setTimeout(() => {
        document.body.removeChild(visibleAnnouncement);
      }, 5000); // 保留一段时间以确保屏幕阅读器能够读取
    }

    // 调用函数发布声明
    announceAccessibilityStatement();
  });
}

function setfocusableAccessibility() {
  const lastFocusableElements = document.querySelectorAll('.last-focusable-element');
  lastFocusableElements.forEach(lastFocusableElement => {
    lastFocusableElement.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        e.preventDefault();
        e.stopPropagation();
        const firstFocusableElement = lastFocusableElement.parentElement.querySelector('.first-focusable-element');
        if (firstFocusableElement) {
          firstFocusableElement.focus();
        } else {
          console.warn('no .first-focusable-element');
        }
      }
    });
  });

  const firstFocusableElements = document.querySelectorAll('.first-focusable-element');
  firstFocusableElements.forEach(firstFocusableElement => {
    firstFocusableElement.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        firstFocusableElement.click();
      }
    });
  });
}

function toggleVideo(videoId) {
  const video = document.getElementById(videoId);
  if (video) {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
}
announcementAccessFun();
setfocusableAccessibility();
toggleVideo();

// Use the rendered amounts so variant, accessory and app prices stay in sync.
(function () {
  const priceSelector = '[data-price-container] .product_on-sale-price, [data-price-container] #ProductPrice, [data-price-container] .product_compare-at-price, [data-price-container] #ComparePrice, .rbr-total-box-rawPrice, .rbr-total-box-price';
  let refreshTimer;
  function enhancePrices() {
    const labels = document.querySelector('[data-product-price-a11y]');
    if (!labels) return;
    document.querySelectorAll(priceSelector).forEach(function (element) {
      const money = element.querySelector('.money');
      const amount = (money || element).textContent.replace(/\s+/g, ' ').trim();
      if (!amount) return;
      const compare = element.matches('.product_compare-at-price, #ComparePrice');
      let label = compare ? labels.dataset.regularLabel : labels.dataset.saleLabel;
      if (element.matches('.rbr-total-box-rawPrice')) label = labels.dataset.bundleRegularLabel;
      else if (element.matches('.rbr-total-box-price')) label = labels.dataset.bundleSaleLabel;
      else if (!compare) {
        const priceContainer = element.closest('[data-price-container]');
        const comparePrice = priceContainer?.querySelector('.product_compare-at-price, #ComparePrice');
        if (!comparePrice?.textContent.trim()) label = labels.dataset.regularLabel;
      }
      element.setAttribute('tabindex', '0');
      element.setAttribute('role', 'group');
      element.setAttribute('aria-label', label + ': ' + amount);
    });
  }
  function initPriceAccessibility() {
    if (!document.querySelector('[data-product-price-a11y]')) return;
    enhancePrices();
    const observer = new MutationObserver(function (mutations) {
      const changed = mutations.some(function (mutation) {
        const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
        if (target?.closest(priceSelector)) return true;
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === Node.ELEMENT_NODE && (node.matches(priceSelector) || node.querySelector(priceSelector));
        });
      });
      if (!changed) return;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(enhancePrices, 80);
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPriceAccessibility);
  else initPriceAccessibility();
})();
